const DrinkMass=[
    {
        id:1,
        title:"Сік 1л",
        price:"200 грн",
        src: require('../img/sandora.webp'),
        text:"250 мл - 50 грн",
    },
    {
        id:11,
        title:"Тоник Schweppes 0,25 скло",
        price:"70 грн",
        src: require('../img/tonicsteklo.png'),
        text:"",
    },
    {
        id:2,
        title:"Тоник Schweppes  0.75 л",
        price:"110 грн",
        src: require('../img/tonicsteklo.png'),
        text:"",
    },
    {
        id:3,
        title:"7UP 0.5 л",
        price:"75 грн",
        src: require('../img/up.webp'),
        text:"",
    },
    // {
    //     id:4,
    //     title:"Мірінда  0.5 л",
    //     price:"75 грн",
    //     src: require('../img/mirinda.webp'),
    //     text:"",
    // },
    {
        id:5,
        title:"Моршинська газ. 0,3 л",
        price:"70 грн",
        src: require('../img/morshs.webp'),
        text:"",
    },
    {
        id:6,
        title:"Моршинська негаз. 0,3 л",
        price:"65 грн",
        src: require('../img/morshnon.webp'),
        text:"",
    },
    {
        id:7,
        title:"Боржомі 0,5л",
        price:"100 грн",
        src: require('../img/borj.webp'),
        text:"",
    },
    {
        id:8,
        title:"Пепсі скло",
        price:"70 грн",
        src: require('../img/pepsi.webp'),
        text:"",
    },
    {
        id:9,
        title:"Пепсі 0,75 л",
        price:"100 грн",
        src: require('../img/pepsil.webp'),
        text:"",
    },
    {
        id:10,
        title:"Пепсі без цукру 1 л",
        price:"120 грн",
        src: require('../img/pepsil.webp'),
        text:"",
    },
    
    
]

export default DrinkMass;